import { render, staticRenderFns } from "./protocols.vue?vue&type=template&id=7120a3b6&"
import script from "./protocols.vue?vue&type=script&lang=js&"
export * from "./protocols.vue?vue&type=script&lang=js&"
import style0 from "./protocols.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports